import TokenView from '@/language/en/views/TokenView';

export default {
  TokenView,
};
